<v2-icon
  *ngIf="showCheckmark()"
  icon="checkmark-small"
  [color]="fillMode === 'fadedCheck' ? 'primary' : 'white'"
></v2-icon>

<span
  *ngIf="fillMode === 'solid' && checked && !disabled"
  class="solid-fill-cont"
></span>

<div
  id="disabled-circle"
  *ngIf="disabled && disabledVariation !== 'line'"
></div>
<div id="disabled-line" *ngIf="disabled && disabledVariation === 'line'"></div>
